const INITIAL_STATE = {
    locations: [],
    twoSteps: [],
    task: undefined,
    filter: {
        taskId: undefined
    }
};

export default function locationReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    switch (action.type) {
        case 'SET_LOCATIONS': {
            return {
                ...state,
                locations: action.locations
            };
        }
        case 'SET_TWO_STEPS': {
            return {
                ...state,
                twoSteps: action.twoSteps
            }
        }
        case 'RESET_LOCATIONS': {
            return {
                ...state,
                locations: INITIAL_STATE.locations,
            };
        }
        case 'SET_TASK': {
            return {
                ...state,
                task: action.taskItem
            };
        }
        default:
            return state;
    }
}
